"use client";
import { SectionTitle } from "../../components/SectionTitle";
import { CarouselSectionProps } from "./types";
import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/scss";
import "swiper/scss/pagination";
import "swiper/scss/navigation";
// import required modules
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import {
  CarouselContainer,
  CarouselFigure,
  ImageCaption,
  ImageTitle,
  Overlay,
  StyledCarouselSection,
} from "./styles";
import { getImage, FULL_WIDTH } from "@itchannelplus/utils";
import { Link } from "../../components/Link";
import {
  NextButton,
  PreviousButton,
} from "../../components/buttons/ControlButtons";
import React, { useState } from "react";
import { ButtonLink } from "../../components/buttons/Button";
import { CarouselModal } from "../../components/CarouselModal";
import Video from "../../components/Video";

export const CarouselSection = ({
  title,
  tagline,
  slides,
  cta,
  children,
  size,
  autoplay,
  fullscreenToggle,
  ...props
}: CarouselSectionProps) => {
  const [fullScreen, setFullScreen] = useState(false);
  return (
    <StyledCarouselSection {...props}>
      {title && <SectionTitle tagline={tagline}>{title}</SectionTitle>}
      <CarouselContainer size={size}>
        <Swiper
          modules={[Autoplay, Pagination, Navigation]}
          spaceBetween={0}
          pagination={{ clickable: true, dynamicBullets: true }}
          navigation={{
            nextEl: ".swiper-navigation-next",
            prevEl: ".swiper-navigation-prev",
          }}
          keyboard={{ onlyInViewport: true, enabled: true }}
          autoplay={autoplay ? { delay: 3000, disableOnInteraction: false } : false}
          //              onSlideChange={ swiper => setActiveSlide(swiper.activeIndex) }
        >
          {slides.map((slide, i) => (
            <SwiperSlide key={"slide-" + i}>
              {({ isActive }) => (
                <CarouselFigure
                  fullscreenToggle={fullscreenToggle && !slide.video}
                >
                  {slide.image && (
                    <Image
                      src={getImage(slide.image)}
                      alt={slide.title || slide.title || "Image"}
                      title={slide.title}
                      fill
                      sizes={FULL_WIDTH}
                      onClick={
                        fullscreenToggle ? () => setFullScreen(true) : undefined
                      }
                    />
                  )}
                  {slide.video && (
                    <Video
                      video={
                        typeof slide.video == "string"
                          ? { src: slide.video, title: slide.title }
                          : slide.video
                      }
                      playing={isActive ? undefined : false}
                    />
                  )}
                  {slide.caption && slide.title && (
                    <Link
                      href={slide.link?.href}
                      {...slide.link}
                      display={"block"}
                    >
                      <Overlay>
                        {slide.caption && (
                          <ImageCaption>{slide.caption}</ImageCaption>
                        )}
                        {slide.title && <ImageTitle>{slide.title}</ImageTitle>}
                      </Overlay>
                    </Link>
                  )}
                </CarouselFigure>
              )}
            </SwiperSlide>
          ))}
        </Swiper>
        <PreviousButton className="swiper-navigation-prev" />
        <NextButton className="swiper-navigation-next" />
      </CarouselContainer>
      {cta && (
        <ButtonLink
          href={cta.href}
          label={cta.label}
          target={cta.target}
          margin={"topMedium"}
          center
          size={"normal"}
          width={"content"}
        />
      )}
      {children}
      {fullScreen && (
        <CarouselModal slides={slides} onClose={() => setFullScreen(false)} />
      )}
    </StyledCarouselSection>
  );
};

export default CarouselSection;
